import {
  GET_AUCTION_IDS,
  GET_AUCTION_BY_ID,
  GET_AUCTION_VIA_VIEWING_AUCTION_MODEL,
  GET_VISIBLE_AUCTION_IDS,
  GET_AUCTIONS_BY_COLLECTION_KEY,
  GET_AUCTIONS_BY_COLLECTION_KEYS,
  HAS_SELECTED_AUCTION_LANE_SUB_FILTER,
  GET_SELECTED_AUCTION_LANE,
  GET_SUBSCRIPTION_BY_AUCTION_ID,
} from './marketplace-auctions.getters.type';

const marketplaceAuctionsGetters = {
  [GET_AUCTION_IDS]: (state) => state
    .auctions
    .map((auction) => auction.id),
  [GET_AUCTION_BY_ID]: (state) => (auctionId) => state
    .auctions
    .find((auction) => auction.id === auctionId),
  [GET_AUCTION_VIA_VIEWING_AUCTION_MODEL]: (state) => state
    .auctions
    .find((auction) => state.viewingAuctionModel && auction.id === state.viewingAuctionModel?.id),
  [GET_VISIBLE_AUCTION_IDS]: (state) => state
    .auctions
    .filter((auction) => auction.visible)
    .map((a) => a.id),
  [GET_AUCTIONS_BY_COLLECTION_KEY]: (state) => (collectionKey) => {
    // Grab the auctions based on the collectionKey
    // Then sort them based on the index in the given collection in ascending
    const sortedAuctions = state
      .auctions
      .filter((auction) => {
        const updatedAuctions = auction
          ?.includeInCollections
          ?.filter((a) => a.fetchMethod === collectionKey);
        return updatedAuctions?.length;
      });

    sortedAuctions.sort((a, b) => {
      const aIndex = a?.includeInCollections
        ?.find((collectionDef) => collectionDef.fetchMethod === collectionKey)
        ?.index || 0;
      const bIndex = b?.includeInCollections
        ?.find((collectionDef) => collectionDef.fetchMethod === collectionKey)
        ?.index || 0;
      return aIndex - bIndex;
    });

    return sortedAuctions;
  },
  [GET_AUCTIONS_BY_COLLECTION_KEYS]: (state, getters) => (collectionKeys) => {
    const sortedAuctions = collectionKeys.reduce((aggregate, currentCollectionKey) => [
      ...aggregate,
      ...getters[GET_AUCTIONS_BY_COLLECTION_KEY](currentCollectionKey),
    ], []);

    return sortedAuctions;
  },
  [HAS_SELECTED_AUCTION_LANE_SUB_FILTER]:
    (state) => !!Object.keys(state.selectedAuctionLaneSubFilter).length,
  [GET_SELECTED_AUCTION_LANE]: (state) => state.selectedAuctionLane,
  [GET_SUBSCRIPTION_BY_AUCTION_ID]: (state) => (auctionId) => state
    .auctionSubscriptions?.[auctionId],
};

export default marketplaceAuctionsGetters;
